const parseBoolean = (value, fallback = false) => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (normalized === 'true') return true;
        if (normalized === 'false') return false;
    }
    return fallback;
};

const getFeaturesRoot = () => {
    if (typeof window === 'undefined') return {};
    const features = window.__FRONTEND_FEATURES__;
    if (!features || typeof features !== 'object') return {};
    return features;
};

export const getFrontendFeatureFlag = (path, fallback = false) => {
    const keys = Array.isArray(path) ? path : [];
    if (keys.length === 0) return fallback;

    const value = keys.reduce((acc, key) => {
        if (!acc || typeof acc !== 'object') return undefined;
        return acc[key];
    }, getFeaturesRoot());

    return parseBoolean(value, fallback);
};
